class TdImageGallery extends HTMLElement {
  constructor() {
    super();
    this.thumbs = this.querySelectorAll(".td-lp-ridge-featured-product__gallery__thumbnail")
    this.images = this.querySelectorAll(".td-lp-ridge-featured-product__gallery__item")
    
  }
  connectedCallback() {
    if (this.thumbs.length) {
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener("click", this.handleThumbClick.bind(this));
      });
    }
  }
  handleThumbClick(e) { 
    if (e.target.classList.contains("active-thumbnail")) return;
    if (this.images.length) {     
      this.images.forEach((image) => image.classList.remove("active-item"));
      this.images[e.target.dataset.thumbnailIndex].classList.add("active-item");
      this.thumbs.forEach((thumb) => thumb.classList.remove("active-thumbnail"));
      e.target.classList.add("active-thumbnail");
    }
  }
}

customElements.define("td-image-gallery", TdImageGallery);